module.exports = __webpack_public_path__ + "media/images/icons/SVG/025-aad53bc9485fa7dd957dbb8765626a82.svg";